/**
 * @description throws a error msg
 * @param {String} msg  msg to throw
 */
export function throwError(msg) {
    throw msg;
}

/**
 * @description logs a errror
 * @param {String} msg msg to log
 */
export function throwConsoleError(msg) {
    console.error(msg);
}
